import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
const MailIcon = () => {
  return (
    <FontAwesomeIcon icon={faEnvelope}/>
  )
}

export default MailIcon